<template>
	<Transition>
		<div
			v-if="tag"
			class="toast h-disp-flex flex-row items-center justify-center flex-1"
			:class="{mobile: isMobileWebApp}"
		>
			<div
				class="content flex-1"
			>
				<div class="message">
					{{ message }}
					<div class="gradient" />
				</div>
				<span
					class="middle"
				>{{ timestamp }}</span>
				<span class="suffix">
					<a
						href="javascript: void(0);"
						@click.prevent="onUndo"
					>
						{{ transUcfirst('commons.undo') }}
					</a>
				</span>
			</div>
		</div>
	</Transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import bus from '@videotools/js/events';
import { TAG_CREATE } from '@videotools/js/events/enum';
import { formatTimestampAsMinutesSeconds } from '@shared/utils/timeUtils';

export default {
	name: 'InPlayerToast',
	data() {
		return {
			message:   '',
			type:      null,
			tag:       null,
			timestamp: null,
			timeout:   null,
		};
	},
	computed: {
		...mapGetters({
			sportName:      'event/sportName',
			isMobileWebApp: 'app/isMobileWebApp',
		}),
	},
	created() {
		bus.subscribe(TAG_CREATE, this.onTagCreate);
	},
	destroyed() {
		bus.unsubscribe(TAG_CREATE, this.onTagCreate);
	},
	methods: {
		...mapActions({
			deleteEventTag: 'event/deleteEventTag',
		}),
		onTagCreate(eventTag) {
			this.tag = eventTag;
			this.message = this.transTagLabel(eventTag.name, this.sportName, eventTag.tag?.type);
			this.timestamp = formatTimestampAsMinutesSeconds(eventTag.timestamp);
			this.type = TAG_CREATE;

			if (this.timeout) {
				clearTimeout(this.timeout);
			}
			this.timeout = setTimeout(this.close, 5000);
		},
		onUndo() {
			if (this.type === TAG_CREATE) {
				this.deleteEventTag(this.tag);
				this.close();
			}
		},
		close() {
			this.tag = null;
			clearTimeout(this.timeout);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.toast {
	height: auto;
	padding: 6px 16px;
	width: 100%;

	.content {
		@include text-sm-2;
		display: flex;
		align-items: center;
		width: 100%;
	}

	.mobile & {
		background-color: var(--color-grey-800);
		color: var(--color-soft-white);
		margin: 8px;
		width: calc(100% - 18px);
		border-radius: 2px;
	}

	.message {
		position: relative;
		flex: 1 0 0;
		text-overflow: clip;
		white-space: nowrap;
		overflow: hidden;
		margin-right: 16px;

		.gradient {
			height: 100%;
			position:absolute;
			width: 20px;
			background: linear-gradient(90deg, rgba(var(--color-rgb-grey-800), 0) 0%, rgba(var(--color-rgb-grey-800), 1) 100%);
			top: 0;
			right: 0;
		}
	}

	.middle {
		padding-right: 32px;
	}

	.middle, .suffix {
		justify-self: flex-end;
	}
}

a {
	text-decoration: none;
	color: var(--color-hype-yellow);
}

.v-enter-active {
	transition: all 0.2s linear;
}

.v-leave-active {
	transition: all 0.5s ease-out;
}

.v-enter,
.v-leave {
	transform: translateY(40px);
	opacity: 0;
}
</style>
